import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, ICON_NAMES } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { t } from "i18next";

import CustomButton from "ui/Button";

export const registrationOverviewGridColumns = ({
	onViewLandingNote,
	onViewSalesNote,
}: {
	onViewLandingNote?: (data: any) => void;
	onViewSalesNote?: (data: any) => void;
}) => {
	const gridItems: GridColumnProps[] = [
		{
			field: "registrationId",
			title: t("RegistrationIdShort"),
			width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "registrationTime",
			title: t("RegistrationTime"),
			width: "140px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "landingTime",
			title: t("DeliveryDateShort"),
			width: "140px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.landingTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationNo"),
			width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "vesselName",
			title: t("VesselName"),
			headerClassName: "no-border",
		},
		{
			field: "species",
			title: t("Species"),
			// width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "catchField",
			title: t("CatchArea"),
			width: "140px",
			headerClassName: "no-border",
		},
		{
			field: "amount",
			title: t("Weight"),
			width: "140px",
			headerClassName: "no-border",
			cells: {
				headerCell: (props) => <NumericalHeader {...props} />,

				data: (props) => <NumericalCell {...props} formatDecimal={2} />,
			},
		},

		{
			field: "fishingGear",
			title: t("FishingGear"),
			width: "160px",
			headerClassName: "no-border",
		},

		{
			field: "",
			title: "",
			width: "60px",
			headerClassName: "no-border",
			cells: {
				data: (props) => {
					return (
						<td style={{ textAlign: "center", border: "none" }}>
							{props.dataItem.numberOfLandingNotes > 0 && (
								<CustomButton
									onClick={() => onViewLandingNote?.(props.dataItem)}
									label="L"
									title={`FD ${t("LandingNotes")}`}
								/>
							)}
						</td>
					);
				},
			},
		},
		{
			field: "",
			title: "",
			width: "60px",
			headerClassName: "no-border",
			cells: {
				data: (props) => {
					return (
						<td
							style={{ textAlign: "center", border: "none", paddingRight: 10 }}
						>
							{props.dataItem.numberOfSalesNotes > 0 && (
								<CustomButton
									onClick={() => onViewSalesNote?.(props.dataItem)}
									label="S"
									title={`FD ${t("SalesNotes")}`}
									labelStyle={{
										textAlign: "center",
									}}
									btnStyle={{}}
								/>
							)}
						</td>
					);
				},
			},
		},

		{
			field: "",
			title: "",
			width: "15px",
			headerClassName: "no-border",
		},
	];

	return [...gridItems];
};

export const lastColumItems = ({
	onLanding,
	onSales,
}: {
	onLanding?: (data: any) => void;
	onSales?: (data: any) => void;
}) => {
	const items: any[] = [
		{
			//iconName: ICON_NAMES.CheckboxBlack,
			title: `FD ${t("LandingNotes")}`,
			alwaysShow: true,
			text: "L",
			handler: (prop: any) => {
				// const colItem: ColumnButtonProps  = {
				const colItem: any = {
					// iconName: itemAlreadyChecked(prop.dataItem.noteNumber)
					// 	? ICON_NAMES.Checkbox
					// 	: ICON_NAMES.CheckboxBlack,
					style: {
						// opacity: handleCanCheck(prop.dataItem.noteStatusId) ? 1 : 0.2,
						// color: "black",
					},
					// alwaysShow: prop.dataItem.numberOfSalesNotes > 0,
					// iconName: ICON_NAMES.CheckboxBlack,
				};

				colItem.onclick = () => {
					onLanding?.(prop.dataItem);
				};
				return colItem;
			},
		},
		{
			// iconName: ICON_NAMES.CheckboxBlack,
			title: `FD ${t("SalesNotes")}`,
			alwaysShow: true,
			text: "S",
			handler: (prop: any) => {
				// const colItem: ColumnButtonProps  = {
				const colItem: any = {
					// iconName:

					style: {
						// opacity: handleCanCheck(prop.dataItem.noteStatusId) ? 1 : 0.2,
						// color: "black",
					},
					// alwaysShow: prop.dataItem.numberOfSalesNotes > 0,
					// iconName: ICON_NAMES.CheckboxBlack,
				};

				colItem.onclick = () => {
					onSales?.(prop.dataItem);
				};
				return colItem;
			},
		},
	];

	return items;
};
